import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { RootState } from '../reduxStore';
import { hideLoader, showLoader } from './loaderSlice';
import { showErrorSnackbar, showSuccessSnackbar } from './snackbarSlice';
import {
  editProfile,
  uploadProfileImg,
} from '../../ApiServices/ProfileUpdateService';
import { t } from 'i18next';
import { handleResponse } from '../../ApiServices/ApiHandler';

export const initialState = {
  value: { totalCount: -1, data: [{}] },
  loading: false,
  error: null,
  selectedValue: null,
  filter: [{}],
};

const profileSlice = createSlice({
  name: 'profile',
  initialState: initialState,
  reducers: {
    clearProfileState(state: any) {
      state.value = initialState.value;
      state.loading = false;
      state.error = null;
      state.selectedValue = initialState.selectedValue;
      state.filter = initialState.filter;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(modifyProfile.fulfilled, (state: any, action: any) => {
      state.error = initialState.error;
      state.loading = initialState.loading;
      state.selectedValue = initialState.selectedValue;
      state.value = action?.payload?.data;
      state.sortDirection = action?.meta?.arg?.sortDirection;
      state.filter = action?.meta?.arg?.filter;
    });
    builder.addCase(modifyProfile.rejected, (state: any, action: any) => {
      state.error = action?.payload?.error?.message;
      state.loading = false;
      state.selectedValue = initialState?.selectedValue;
    });
  },
});

export const profileState = (state: RootState) => state?.languages;
export const { clearProfileState } = profileSlice.actions;
export default profileSlice.reducer;

export const modifyProfile = createAsyncThunk(
  'profile/modifyprofile',
  async (payload: any, { fulfillWithValue, rejectWithValue, dispatch }) => {
    try {
      dispatch(showLoader({ message: t('MODIFYING_PROFILE') }));
      let response = await editProfile(payload);
      return await handleResponse(
        response,
        fulfillWithValue,
        rejectWithValue,
        dispatch
      );
    } catch (error) {
      dispatch(showErrorSnackbar({ message: error }));
      return rejectWithValue(error);
    } finally {
      dispatch(hideLoader());
    }
  }
);

export const uploadProfileImage = createAsyncThunk(
  'profile/uploadProfileImage',
  async (payload: any, { fulfillWithValue, rejectWithValue, dispatch }) => {
    try {
      dispatch(showLoader({ message: t('UPLOADING_PROFILE_IMAGE') }));
      let response: any = await uploadProfileImg(payload);
      if (response?.status === 200 || response === 200) {
        dispatch(
          showSuccessSnackbar({ message: t('PROFILE_UPLOADED_SUCCESS') })
        );
        return fulfillWithValue(response);
      } else {
        dispatch(showErrorSnackbar({ message: t('PROFILE_UPLOAD_FAILED') }));
        return rejectWithValue(response);
      }
      // return await handleResponse(response, fulfillWithValue, rejectWithValue, dispatch);
    } catch (error) {
      dispatch(showErrorSnackbar({ message: error }));
      return rejectWithValue(error);
    } finally {
      dispatch(hideLoader());
    }
  }
);
